import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/** Redirects brokers away from staff-only home dashboard. */
const HomeRoute = ({ children }) => {
  const role = useSelector((state) => state.role);
  if (role === "broker") {
    return <Navigate to="/broker-commissions" replace />;
  }
  return children;
};

export default HomeRoute;
